var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconFrontpageYoutube = function SvgIconFrontpageYoutube(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".youtube-a,.youtube-b{fill:currentColor;}.youtube-a{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.481)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "youtube-a",
    width: 34,
    height: 34,
    transform: "translate(-0.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-b",
    d: "M28.969,9.661a3.272,3.272,0,0,0-2.319-2.33c-2.039-.56-10.241-.56-10.241-.56s-8.2,0-10.241.56a3.272,3.272,0,0,0-2.319,2.33,34.453,34.453,0,0,0-.549,6.33,34.52,34.52,0,0,0,.549,6.353,3.238,3.238,0,0,0,2.319,2.241c2.039.56,10.241.56,10.241.56s8.2,0,10.241-.56a3.238,3.238,0,0,0,2.319-2.241,34.52,34.52,0,0,0,.549-6.353A34.453,34.453,0,0,0,28.969,9.661ZM13.731,19.912V12.07l6.846,3.921Z",
    transform: "translate(0.304 0.815)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFrontpageYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-frontpage-youtube.8e91ef51.svg";
export { ForwardRef as ReactComponent };